import React from 'react';
import InteractiveOnboarding from '@/components/InteractiveOnboarding';
import { Card, CardContent } from '@vaiu/ui/card';
import { MessageCircle } from 'lucide-react';

interface ProspectiveUserChatProps {
  className?: string;
}

const ProspectiveUserChat: React.FC<ProspectiveUserChatProps> = ({ className = '' }) => {
  return (
    <section className={`py-12 px-4 sm:px-6 lg:px-8 ${className}`}>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center p-3 bg-blue-100 rounded-full mb-4">
            <MessageCircle className="w-8 h-8 text-blue-600" />
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            Join the Marketplace
          </h2>
          <p className="text-lg text-gray-600">
            Let's discover what we can do for you! Chat with us to explore features and find out how we're building the simplest, safest, most inclusive payment network.
          </p>
        </div>

        <Card className="shadow-xl border-2 border-blue-100">
          <CardContent className="p-0">
            <InteractiveOnboarding />
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ProspectiveUserChat;
